module.exports = __webpack_public_path__ + "img/picto_handShake_white.418b8262.svg";